import { setAuthToken as setAxiosToken } from '@common/api/axiosInstance';
import { useNotificationsStore } from '@common/store/notifications';
import {
  AccountError,
  ErrorMessage,
  LoginResponse,
  PropertiesResponse,
  ssoApaleo,
  ssoApaleoAuth,
  SSOAuthInput,
  ssoCloudbeds,
  ssoCloudbedsAuth,
  ssoFreetobook,
  SSOInput,
  ssoSeekom,
  ssoSeekomAuth
} from '@common/api/auth';
import { useAuthStore, useLogout } from '@common/store/auth';
import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useTranslation } from 'react-i18next';

export const useSSOApaleo = () => {
  const { t } = useTranslation();
  const addNotification = useNotificationsStore((state) => state.addNotification);
  const { setAuth } = useAuthStore();

  return useMutation<PropertiesResponse, AxiosError<ErrorMessage>, SSOInput>({
    mutationFn: ssoApaleo,
    onSuccess: async (data) => {
      // Set token for all axios requests
      setAxiosToken(data.token);

      setAuth(data.token, null);
    },
    onError: () => {
      addNotification('fail', t('Something went wrong'));
    }
  });
};

export const useSSOApaleoAuth = () => {
  const { t } = useTranslation();
  const addNotification = useNotificationsStore((state) => state.addNotification);
  const { setAuth } = useAuthStore();
  const clientLogout = useLogout();

  return useMutation<LoginResponse, AccountError, SSOAuthInput>({
    mutationFn: ssoApaleoAuth,
    onSuccess: async (data) => {
      if (!data.token || !data.user) {
        clientLogout();
        return;
      }

      // Set token for all axios requests
      setAxiosToken(data.token);
      setAuth(data.token, data.user);

      addNotification('success', t('SSO Successful'));
    },
    onError: () => {
      addNotification('fail', t('SSO Failed'));
    }
  });
};

export const useSSOFreetobook = () => {
  const { t } = useTranslation();
  const addNotification = useNotificationsStore((state) => state.addNotification);
  const { setAuth } = useAuthStore();
  const clientLogout = useLogout();

  return useMutation<LoginResponse, AccountError, SSOInput>({
    mutationFn: ssoFreetobook,
    onSuccess: async (data) => {
      if (!data.token || !data.user) {
        clientLogout();
        return;
      }

      // Set token for all axios requests
      setAxiosToken(data.token);
      setAuth(data.token, data.user);
    },
    onError: () => {
      addNotification('fail', t('Something went wrong'));
    }
  });
};

export const useSSOSeekom = () => {
  const { t } = useTranslation();
  const addNotification = useNotificationsStore((state) => state.addNotification);
  const { setAuth } = useAuthStore();

  return useMutation<PropertiesResponse, AxiosError<ErrorMessage>, SSOInput>({
    mutationFn: ssoSeekom,
    onSuccess: async (data) => {
      // Set token for all axios requests
      setAxiosToken(data.token);

      setAuth(data.token, null);
    },
    onError: () => {
      addNotification('fail', t('Something went wrong'));
    }
  });
};

export const useSSOSeekomAuth = () => {
  const { t } = useTranslation();
  const addNotification = useNotificationsStore((state) => state.addNotification);
  const { setAuth } = useAuthStore();
  const clientLogout = useLogout();

  return useMutation<LoginResponse, AccountError, SSOAuthInput>({
    mutationFn: ssoSeekomAuth,
    onSuccess: async (data) => {
      if (!data.token || !data.user) {
        clientLogout();
        return;
      }

      // Set token for all axios requests
      setAxiosToken(data.token);
      setAuth(data.token, data.user);

      addNotification('success', t('SSO Successful'));
    },
    onError: () => {
      addNotification('fail', t('SSO Failed'));
    }
  });
};

export const useSSOCloudbeds = () => {
  const { t } = useTranslation();
  const addNotification = useNotificationsStore((state) => state.addNotification);
  const { setAuth } = useAuthStore();

  return useMutation<PropertiesResponse, AxiosError<ErrorMessage>, SSOInput>({
    mutationFn: ssoCloudbeds,
    onSuccess: async (data) => {
      // Set token for all axios requests
      setAxiosToken(data.token);

      setAuth(data.token, null);
    },
    onError: () => {
      addNotification('fail', t('Something went wrong'));
    }
  });
};

export const useSSOCloudbedsAuth = () => {
  const { t } = useTranslation();
  const addNotification = useNotificationsStore((state) => state.addNotification);
  const { setAuth } = useAuthStore();
  const clientLogout = useLogout();

  return useMutation<LoginResponse, AccountError, SSOAuthInput>({
    mutationFn: ssoCloudbedsAuth,
    onSuccess: async (data) => {
      if (!data.token || !data.user) {
        clientLogout();
        return;
      }

      // Set token for all axios requests
      setAxiosToken(data.token);
      setAuth(data.token, data.user);
    },
    onError: () => {
      addNotification('fail', t('Something went wrong'));
    }
  });
};
